import * as lienStyles from "../../../styles/widgets/lien.module.scss";

import {GatsbyImage, getImage} from "gatsby-plugin-image";

import PolyLink from "../PolyLink";
import React from "react";
import clsx from "clsx";
import {altNN} from "../../../utils/parsing";

const Lien = ({style, link, title, orientation = "CENTER", image, content, alt, newWindow = false}) => {
    const divBloc = () => {

        return (<div
            className={link ? style !== "FRAME" && !image ? clsx(lienStyles.bloc, lienStyles.noBackground) : clsx(lienStyles.bloc, lienStyles.background) : clsx(lienStyles.bloc)}
        >
            <div className={lienStyles.root}>
                {image ? (<GatsbyImage
                    image={getImage(image.imageFile)}
                    style={{height: "100%"}}
                    alt={altNN(alt)}
                    className={lienStyles.image}
                ></GatsbyImage>) : (<div className={lienStyles.emptyImage}></div>)}
                {style === "FRAME" ? (<div className={lienStyles.mainBloc_frame}>
                    <p className={clsx(lienStyles.h1, lienStyles.nbLines)}>
                        {title}
                    </p>
                </div>) : style === "CTA" ? (<div className={lienStyles.mainBloc_cta}>
                    <div className={lienStyles.titleBloc_cta}>
                        <p className={clsx(lienStyles.h1, lienStyles.nbLines)}>
                            {title}
                        </p>
                    </div>
                    <div className={lienStyles.contentBloc_cta}>
                        <p className={clsx(lienStyles.content_cta, lienStyles.h5ContentCTA)}>
                            {content}
                        </p>
                    </div>
                </div>) : image ? (<div className={clsx({
                    [lienStyles.mainBlocTop]: orientation === "TOP",
                    [lienStyles.mainBlocBottom]: orientation.includes("BOTTOM")
                }, lienStyles.mainBloc)}>
                    <div className={lienStyles.containerTitle}>
                        <div className={clsx({
                            [lienStyles.contentTitleLeft]: orientation.includes("LEFT"),
                            [lienStyles.contentTitleRight]: orientation.includes("RIGHT")
                        }, lienStyles.contentTitle)}>
                            <p className={lienStyles.h2}>
                    <span className={lienStyles.backgroundText}>
                      {title}
                    </span>
                            </p>
                        </div>
                    </div>
                </div>) : (<div className={clsx({
                    [lienStyles.mainBlocTop]: orientation === "TOP",
                    [lienStyles.mainBlocBottom]: orientation.includes("BOTTOM")
                }, lienStyles.mainBloc)}>
                    <div className={clsx({
                        [lienStyles.contentTitleLeft]: orientation.includes("LEFT"),
                        [lienStyles.contentTitleRight]: orientation.includes("RIGHT")
                    }, lienStyles.contentTitle)}>
                        <p className={lienStyles.h3}>{title}</p>
                        <p className={clsx(lienStyles.nbLinesContent, lienStyles.h4)}>
                            {content}
                        </p>
                    </div>
                </div>)}
            </div>
        </div>);
    };

    if (link) {
        return (
            <PolyLink style={{display: "block"}} url={link} target={newWindow ? "_blank" : ""}>
                {divBloc()}
            </PolyLink>
        );
    } else {
        // no link
        return divBloc();
    }
};

export default Lien;
